import React, { Fragment } from "react";
import DataTable from "../../../components/WindowDoor/DataTable";

const ExteriorOrders = () => {
  return (
    <Fragment>
      <DataTable
        title="Exterior Orders"
        subtitle="Track and request delivery for your window & door orders."
      />
    </Fragment>
  );
};

export default ExteriorOrders;
